import isNil from 'lodash/isNil';
import {Component} from 'panel';

import {propagateEvent} from 'common/util/dom';
import {defineAndMakeJsxFactory} from 'common/util/jsx';

import {CustomEventModalInternal} from './custom-event-modal-internal';
import template from './index.jade';

/**
 * This component is a thin wrapper around the core component, which is mp-custom-event-modal-internal. It does nothing but
 * place that component in the appropriate position in the DOM and proxy attributes to it. This allows appropriate positioning
 * and styling of the modal no matter where it is inserted into the DOM by the caller.
 */

export class CustomEventModal extends Component {
  static get attrsSchema() {
    return {
      ...super.attrsSchema,
      ...CustomEventModalInternal.attrsSchema,
    };
  }

  get config() {
    return {
      template,
      useShadowDom: true,
    };
  }

  connectedCallback() {
    super.connectedCallback(...arguments);
    this.modal = document.createElement(`mp-custom-event-modal-internal`);
    document.body.appendChild(this.modal);
    this.handlers = CustomEventModalInternal.dispatchedEvents.reduce((handlersObj, eventName) => {
      handlersObj[eventName] = (ev) => propagateEvent(this, ev);
      this.modal.addEventListener(eventName, handlersObj[eventName]);
      return handlersObj;
    }, {});
    CustomEventModalInternal.observedAttributes.forEach((attr) => {
      if (this.hasAttribute(attr)) {
        this.modal.setAttribute(attr, this.getAttribute(attr));
      }
    });
  }

  disconnectedCallback() {
    document.body.removeChild(this.modal);
    CustomEventModalInternal.dispatchedEvents.forEach((eventName) => {
      this.modal.removeEventListener(eventName, this.handlers[eventName]);
    });
    super.disconnectedCallback(...arguments);
  }

  attributeChangedCallback(attr) {
    super.attributeChangedCallback(...arguments);
    if (this.modal) {
      if (!isNil(this.attr(attr))) {
        this.modal.setAttribute(attr, this.getAttribute(attr));
      } else {
        this.modal.removeAttribute(attr);
      }
    }
  }
}

export const CustomEventModalEl = defineAndMakeJsxFactory(`mp-custom-event-modal`, CustomEventModal);
